const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const withSetURL = require("../core/hoc/withSetURL");
const AT = require("../core/vault/ActionTypes");
const Slots = require("../core/vault/Slots");
const ReportBody = require("./ReportBody");
const AccountBody = require("./AccountBody");
const LoadGuard = require("../core/view/LoadGuard");
const UserSearch = require("./UserSearch");
const TeacherSupport = require("./TeacherSupport");
const OfficeModal = require("../office/modals/OfficeModal");
const CopyTable = require("../office/data/CopyTable");
const AssetsUtil = require("../core/util/AssetsUtil");

const styles = require("./styles/PageSchool.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withSetURL(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => ({
			relations: Slots.getValue(vaultState, Slots.table.schoolEntities()),
		}),
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PageSchool",

		propTypes: {
			user: PT.object.isRequired,
			space: PT.string,
			tab: PT.string,
			pageData: PT.object,
			setNextScrollTo: PT.func.isRequired,

			// Injected by HOCs
			setURL: PT.func.isRequired,
			dispatch: PT.func.isRequired,
			relations: PT.object.isRequired,
		},

		getInitialState: function() {
			return {
				showWelcome: false,
			};
		},

		vaultEvents: {
			showTeacherWelcome: function() {
				this.setState({showWelcome: true});
			},
		},

		componentDidMount: function() {
			window.addEventListener("scroll", this.handleScroll);
		},

		componentWillUnmount: function() {
			window.removeEventListener("scroll", this.handleScroll);
		},

		handleScroll: function() {
			if (this.state.showWelcome) {
				if (
					document.body.scrollTop > 50 ||
					document.documentElement.scrollTop > 50
				) {
					this.setState({hideArrow: true});
				} else {
					this.setState({hideArrow: false});
				}
			}
		},

		onWelcomeClose: function() {
			this.setState({showWelcome: false});
		},

		loadRelations: function() {
			this.props.dispatch({
				type: AT.LOAD_SCHOOL_ENTITIES_SLOT_REQUEST,
			});
		},

		onSelect: function(url) {
			this.props.setURL(url);
		},

		renderSearch: function() {
			const {space, relations} = this.props;
			let placeholder;
			if (space === "accounts") {
				placeholder = "Search a class or user";
			} else if (space === "reports") {
				placeholder = "Search a class or students";
			}
			return (
				<UserSearch
					users={relations.relations}
					placeholder={placeholder}
					onSelect={this.onSelect}
					space={space}
				/>
			);
		},

		makeUserSearch: function() {
			const {space, relations} = this.props;
			return (
				<LoadGuard
					identifier="allRelations"
					status={relations}
					requestLoad={this.loadRelations}
					loadingView={"logo"}
					logoColorType={space === "reports" ? "white" : "blue"}
					loadingViewClass={styles.loading}
					errorView="refreshOffice"
					renderLoaded={this.renderSearch}
				/>
			);
		},

		render: function() {
			const arrowStyle = this.state.hideArrow ? styles.hideArrow : styles.arrow;
			let welcomeModal = null;

			if (this.state.showWelcome) {
				const copy = CopyTable.getTeacherTutorialModal(styles, this.props.user)
					.welcome;

				welcomeModal = (
					<OfficeModal
						modalClass={styles.welcomeModal}
						cannotClose={true}
						onClose={this.onWelcomeClose}
						closeOnEsc={true}
						portalContainer={null}
						level="overBar"
						closeOnBackdropClick={false}
						isScrollable={false}
						isFixed={false}
					>
						<div className={arrowStyle}>
							<img src={AssetsUtil.getParentTutorialImage("arrow-straight")} />
						</div>
						<div className={styles.welcomeModalContainer}>
							<div className={styles.welcomeModalTitle}>{copy.title}</div>

							<div className={styles.welcomeModalContentsContainer}>
								<div className={styles.welcomeModalImage}>
									<img src={AssetsUtil.getBeastInstruction("headmaster", 5)} />
								</div>
								{copy.contents}
							</div>
							<div className={styles.button} onClick={this.onWelcomeClose}>
								{copy.buttonText}
							</div>
						</div>
					</OfficeModal>
				);
			}

			const {space, tab, pageData, user, setNextScrollTo} = this.props;
			if (space === "reports") {
				return (
					<div className={styles.reports}>
						<div className={styles.reportTop}>
							<div className={styles.title}>Reports</div>
							{this.makeUserSearch()}
						</div>
						<div className={styles.content}>
							<ReportBody user={user} tab={tab} pageData={pageData} />
						</div>
						{welcomeModal}
					</div>
				);
			} else if (space === "accounts") {
				return (
					<div className={styles.accounts}>
						<div className={styles.accountTop}>
							<div className={styles.title}>Accounts</div>
							{this.makeUserSearch()}
						</div>
						<AccountBody user={user} tab={tab} pageData={pageData} />
						{welcomeModal}
					</div>
				);
			} else if (space === "support") {
				return (
					<TeacherSupport
						tab={tab}
						topic={pageData.topic}
						user={user}
						setNextScrollTo={setNextScrollTo}
					/>
				);
			} else {
				return null;
			}
		},
	})
);
